import { FunctionComponent } from 'react'
import { Chip } from '@black-bear-energy/rucksack'
import { ConstructionStatusAPIResponse } from '@black-bear-energy/black-bear-energy-common'
import { statusChipColors } from '../helpers/DocumentExchange/statusChipColors'

export const ConstructionStatusChip: FunctionComponent<
  ConstructionStatusChipProps
> = ({ status }) => {
  const statusLabels = {
    [ConstructionStatusAPIResponse.PreNTP]: 'Pre-NTP',
    [ConstructionStatusAPIResponse.IncentiveAllocation]: 'Incentive Allocation',
    [ConstructionStatusAPIResponse.IXCostApproved]: 'IX Cost Approved',
    [ConstructionStatusAPIResponse.NTP]: 'NTP',
    [ConstructionStatusAPIResponse.ConstructionStart]: 'Construction Start',
    [ConstructionStatusAPIResponse.MechanicallyComplete]:
      'Mechanically Complete',
    [ConstructionStatusAPIResponse.ConstructionComplete]:
      'Construction Complete',
    [ConstructionStatusAPIResponse.FinalComplete]: 'Final Complete',
  }
  const statusLabel = statusLabels[status]
  const statusSx = {
    [ConstructionStatusAPIResponse.PreNTP]: statusChipColors.derisking,
    [ConstructionStatusAPIResponse.IncentiveAllocation]:
      statusChipColors.derisking,
    [ConstructionStatusAPIResponse.IXCostApproved]: statusChipColors.derisking,
    [ConstructionStatusAPIResponse.NTP]: statusChipColors.ntp,
    [ConstructionStatusAPIResponse.ConstructionStart]:
      statusChipColors.construction,
    [ConstructionStatusAPIResponse.MechanicallyComplete]:
      statusChipColors.construction,
    [ConstructionStatusAPIResponse.ConstructionComplete]:
      statusChipColors.complete,
    [ConstructionStatusAPIResponse.FinalComplete]: statusChipColors.complete,
  }

  return (
    <Chip
      label={statusLabel}
      size="small"
      sx={{
        ...statusSx[status],
        fontSize: '14px',
        fontWeight: 400,
        alignItems: 'flex-start',
      }}
    />
  )
}

interface ConstructionStatusChipProps {
  status: ConstructionStatusAPIResponse
}
